<bw-action-article-legacy [brightsideWebFb]="displayReviewAnalytics.shown" minHeight="0">
  <div header-actions class="flex-row pointer">
    <bw-icon-legacy
      *ngIf="config.pageHideBackButton; else showBackButton"
      color="var(--secondary-text)"
      iconName="close"
      [brightsideWebFb]="displayReviewAnalytics.dismiss"
      (click)="handleCloseAction()"
    ></bw-icon-legacy>

    <ng-template #showBackButton>
      <ui-nav-exit-back
        *ngIf="!pageIsFullScreen"
        back-action-top
        [trackingDetail]="displayReviewAnalytics.dismiss"
        [skipActionEmit]="!config.pageOnBackCtaPath"
        (exitActionHandler)="handleCloseAction()"
      ></ui-nav-exit-back>
      <ui-nav-exit-back
        *ngIf="pageIsFullScreen"
        back-action-bottom
        [trackingDetail]="displayReviewAnalytics.dismiss"
        [skipActionEmit]="!config.pageOnBackCtaPath"
        (exitActionHandler)="handleCloseAction()"
      ></ui-nav-exit-back>
    </ng-template>
  </div>

  <div *ngIf="config.pageTitle" header-title class="flex-row space-between flex-end">
    <typography-legacy title-medium class="mb-sm">{{ config.pageTitle | translate }}</typography-legacy>
  </div>

  <div content-section>
    <p *ngIf="config.pageSubTitle" text-large-regular class="mb-sm">{{ config.pageSubTitle | translate }}</p>

    <a
      *ngIf="config.pageExtraModal"
      bw-anchor-legacy
      anchorStyle="text-large-regular"
      class="mr-xxs"
      mwTextColor="var(--secondary-text)"
      style="text-decoration: underline"
      (click)="pageExtraModalIsShowing = true"
    >
      {{ config.pageExtraModal.triggerText | translate }}
    </a>

    <section class="mt-md mb-xs">
      <ng-container *ngIf="!config?.pageDisplayCells?.length; else cellDisplaySection">
        <p text-large-semibold>{{ config.pageEmptyText | translate }}</p></ng-container
      >

      <ng-template #cellDisplaySection>
        <ng-container *ngFor="let cellInfo of config.pageDisplayCells">
          <bw-cell-legacy
            *ngIf="!cellInfo?.value; else multiLineDisplay"
            separatorType="full"
            [singleLeftLabel]="cellInfo.label | translate"
            iconNameRight="chevron_right"
            (clicked)="handleCellClick(cellInfo)"
          ></bw-cell-legacy>

          <ng-template #multiLineDisplay>
            <bw-cell-legacy
              *ngIf="!config.pageShowAsFlipped"
              [labelLeft]="cellInfo.label | translate"
              [labelRight]="cellInfo.value | translate"
              separatorType="full"
            >
            </bw-cell-legacy>

            <bw-cell-legacy
              *ngIf="config.pageShowAsFlipped"
              [labelLeft]="cellInfo.label | translate"
              [labelSubLeft]="cellInfo.value | translate"
              [flipLeftLabels]="true"
              separatorType="full"
            >
            </bw-cell-legacy>
          </ng-template>
        </ng-container>
      </ng-template>

      <div *ngFor="let questionAnswer of config.pageDisplayQuestionAnswer" class="mt-md mb-sm">
        <bw-paragraph-legacy textStyle="Body2"><span [innerHTML]="questionAnswer.label | translate"></span></bw-paragraph-legacy>
        <p text-large-semibold [innerHTML]="questionAnswer.value | translate"></p>
      </div>

      <div *ngIf="config.pageAddActionText" class="flex-row mt-md mr-md" (click)="handleAddAction()">
        <bw-icon-legacy iconName="add" color="var(--brand)"></bw-icon-legacy>
        <p text-large-regular class="brand ml-sm">{{ config.pageAddActionText | translate }}</p>
      </div>
    </section>
  </div>
  <div footer-top>
    <div class="mt-md" *ngIf="config.pageExtraInfoListDetail">
      <bw-list-item-details-legacy
        [avatarIconName]="config.pageExtraInfoListDetail.avatarTitle"
        [avatarIconColor]="config.pageExtraInfoListDetail.avatarBg"
        [blockStyle]="true"
        [bgColor]="config.pageExtraInfoListDetail.bgColor"
        [listTitle]="config.pageExtraInfoListDetail.title | translate">
      </bw-list-item-details-legacy>
    </div>
  </div>
  <div footer-actions class="flex-row row-reverse">
    <button
      *ngIf="config.pageCtaLabel || config.pageCtaLabelKey"
      bw-button-legacy
      [processing]="processing"
      [brightsideWebFb]="displayReviewAnalytics.submit"
      (click)="handleCtaClick()"
    >
      {{ config.pageCtaLabelKey || config.pageCtaLabel | translate }}
    </button>

    <typography-legacy text-large-semibold>
      <a
        *ngIf="config.pageSecondaryCtaLabel"
        bw-anchor-legacy
        class="bs-blue mr-sm"
        [brightsideWebFb]="{ event_name: 'display_review_secondary' }"
        (click)="handleSecondaryCtaClick()"
        >{{ config.pageSecondaryCtaLabel | translate }}</a
      >
    </typography-legacy>
  </div>
</bw-action-article-legacy>

<bw-modal-legacy
  *ngIf="pageExtraModalIsShowing"
  (closeModal)="pageExtraModalIsShowing = false"
  [brightsideWebFb]="{ event_name: config.fbEventName + 'more_info' }"
>
  <typography-legacy title-medium color="var(--gray-70)">{{ config.pageExtraModal.title | translate }}</typography-legacy>
  <section class="body">
    <bw-paragraph-legacy *ngFor="let bodyText of config.pageExtraModal.body" [textStyle]="'Body2'" color="var(--gray-50)">
      <span [innerHTML]="bodyText | translate"></span>
    </bw-paragraph-legacy>
  </section>
  <footer class="footer">
    <div class="flex-row row-reverse">
      <button
        bw-button-legacy
        (click)="pageExtraModalIsShowing = false"
        [brightsideWebFb]="{ event_name: config.fbEventName + 'more_info' }"
      >
        {{ config.pageExtraModal.cta | translate }}
      </button>
    </div>
  </footer>
</bw-modal-legacy>
